import React from "react";
import {GatsbyImage} from "gatsby-plugin-image";
import {Link} from "gatsby";
import { renderText } from "../utils/render-text";
import { createPath } from "../utils/create-path";


const shareOnSocialMedia = (socialMedia) => {
    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
    if (socialMedia === 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`);
    } else if (socialMedia === 'twitter') {
        window.open(`https://twitter.com/intent/tweet?url=${currentUrl}`);
    } else if (socialMedia === 'pinterest') {
        window.open(`https://pinterest.com/pin/create/button/?url=${currentUrl}`);
    }

}

const ArticleSingle = ({title, date, body, author, mainImage, otherArticles}) => {
    return (
        <section className="causes-detail-area news-detail-area">
            <div className="container">
                <div className="row blog-content-wrap">
                    <div className="col-lg-8">
                        <div className="blog-content">
                            <div className="blog-item">
                                <div className="blog-img">
                                    <GatsbyImage image={mainImage.gatsbyImageData} alt={title}/>
                                    <span className="blog__date">{date}</span>
                                </div>
                                <div className="blog-inner-content">
                                    <div className="inner-causes-box">
                                        <h3 className="blog__title">
                                            <a href="#none">{title}</a>
                                        </h3>
                                    </div>
                                </div>
                                <div className="blog-inner-content-2">
                                    <div className="rich-contentblock">
                                        {renderText(body)}
                                    </div>
                                    <div className="news-tags">

                                        <div className="news-tag-item-right">
                                            <ul className="news-share">
                                                <li>
                                                    <a onClick={() => shareOnSocialMedia('facebook')} >
                                                        <i className="fa fa-facebook"></i>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={() => shareOnSocialMedia('twitter')} >
                                                        <i className="fa fa-twitter"></i>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={() => shareOnSocialMedia('pinterest')} >
                                                        <i className="fa fa-pinterest"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="sidebar-shared">
                            <div className="side-widget">
                                <h2 className="widget__title">Meer artikelen</h2>
                                {otherArticles.map(({
                                                        id,
                                                        title,
                                                        mainImage,
                                                        date
                                                    }) => {
                                    const articlePath = `/artikelen/${createPath(title)}`
                                    return (
                                      <div className="author-box recent-donate-item" key={id}>
                                          <div className="author__avatar">
                                              <Link to={articlePath}>
                                                  <GatsbyImage image={mainImage.gatsbyImageData} alt={title} />
                                              </Link>
                                          </div>
                                          <div className="author__detail">
                                              <h4 className="author__title author__title2">
                                                  <Link to={articlePath}>
                                                      <span>{date}</span><br></br>
                                                      {title}
                                                  </Link>
                                              </h4>
                                          </div>
                                      </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ArticleSingle;
